import React from "react";
import { useTranslation } from "react-i18next";
import { List } from "../../Components/List";
import { MenuContentListItem } from "./MenuContentListItem";
import type { MenuContentCoursesProps } from "./Menu.types";
import styles from "./LeftMenu.module.css";
import SidebarSection from "./SidebarSection";

export function MenuContentCourses({
  userEducations,
  selectedCourse,
  hideProgress,
  title,
  sectionIcon,
  compact = false,
  onExpandSidebar,
  handleCourseClick,
  isCertificateSection = false,
  isExpiredSection = false,
  isCollapsible = false,
  isCollapsed = false,
  onToggleCollapse,
}: MenuContentCoursesProps) {
  const { t } = useTranslation();

  return (
    <SidebarSection
      title={title}
      icon={sectionIcon}
      compact={compact}
      onExpandSidebar={onExpandSidebar}
      collapsible={isCollapsible}
      expanded={!isCollapsible || !isCollapsed}
      onToggle={onToggleCollapse}
    >
      {userEducations.length === 0 ? (
        <div className={styles.emptyMessage}>
          {t("menu.noActiveEducations")}
        </div>
      ) : (
        <List className="menuList">
          {userEducations.map((course) => (
            <MenuContentListItem
              key={course.ID}
              course={course}
              selectedCourse={selectedCourse}
              handleCourseClick={handleCourseClick}
              hideProgress={hideProgress}
              isCertificateSection={isCertificateSection}
              isExpiredItem={isExpiredSection}
            />
          ))}
        </List>
      )}
    </SidebarSection>
  );
}
